var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.23,229.29s-.42-.11-1.17-.26a9.63,9.63,0,0,0-3.23-.09,8.77,8.77,0,0,0-4.31,1.89,9,9,0,0,0-3,4.85l0,0-.18.72-.28-.68a9.68,9.68,0,0,0-3.64-4.42,9.4,9.4,0,0,0-4.46-1.51,12.55,12.55,0,0,0-4.37.55,3.94,3.94,0,0,1,1.11-.48,9.21,9.21,0,0,1,3.28-.41A9.44,9.44,0,0,1,441.6,231a9.88,9.88,0,0,1,3.85,4.61l-.46,0,0-.05a9.26,9.26,0,0,1,3.23-5.08,9,9,0,0,1,7.86-1.64A3.69,3.69,0,0,1,457.23,229.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.61,170.39s-.42-.11-1.17-.26a9.63,9.63,0,0,0-3.23-.09,8.68,8.68,0,0,0-4.31,1.89,9,9,0,0,0-3,4.85l0,.05-.18.72-.28-.68a9.68,9.68,0,0,0-3.64-4.42,9.4,9.4,0,0,0-4.46-1.51,12.55,12.55,0,0,0-4.37.55A3.76,3.76,0,0,1,61,171a9.21,9.21,0,0,1,3.28-.41A9.44,9.44,0,0,1,69,172.08a9.94,9.94,0,0,1,3.85,4.61l-.46,0,0-.05a9.26,9.26,0,0,1,3.23-5.08A8.88,8.88,0,0,1,83.48,170,3.69,3.69,0,0,1,84.61,170.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.3,149.74a13.43,13.43,0,0,1-1.07,1.23,26.81,26.81,0,0,0-2.62,3.57,25.88,25.88,0,0,0-3.9,13.83v.17l-.48,0a23.24,23.24,0,0,0-6.37-12.69,31.84,31.84,0,0,0-4.66-3.77s.14,0,.39.17.6.31,1,.6a20.88,20.88,0,0,1,3.47,2.76,22.83,22.83,0,0,1,6.6,12.86l-.48,0v-.17a25.41,25.41,0,0,1,4.1-14,22.69,22.69,0,0,1,2.77-3.5c.36-.39.68-.66.88-.85A1.45,1.45,0,0,1,343.3,149.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.15,389.37C362.4,393.1,350.38,408.8,350.88,425c-10.09-11.12-28.54-13.39-41-5s-17.43,26.27-11,39.84c-14.91-11.64-39.16-8.41-50.51,6.72a31.53,31.53,0,0,0-47.51-18.25c-2.69-16.87-16.31-31.47-33-35.33s-35.29,3.28-45.12,17.25A38,38,0,0,0,63,438.85l10.11,3.26a55.43,55.43,0,0,1,41.18,34.57,43,43,0,0,1,69.85,9.12l77.85,0c19.38-.16,34.17.88,52.09,0,7.08-24.93,39.67-47.09,64.16-38.63a54.67,54.67,0,0,1,40-38.68C411.3,394.07,393.73,385.67,378.15,389.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.91,408.31l-.63.14c.08.16.17.32.24.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.7,362.07c.6-4.33-5.52-7.9-10.11-8.27-2.2-.17-4.47.16-6.55-.56-4.5-1.57-6.29-7.38-10.68-9.23-3.28-1.39-7.06-.15-10.24,1.45s-6.32,3.61-9.88,3.84c-3.09.2-6.45-.95-9.15.56-2,1.13-3.07,3.45-4.93,4.82s-4.19,1.62-6.44,1.75-4.59.14-6.64,1.08-3.75,3.11-3.33,5.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.07,118.35c.71-5.16-6.56-9.39-12-9.83-2.61-.21-5.32.18-7.78-.68-5.35-1.86-7.49-8.77-12.71-11-3.9-1.65-8.39-.18-12.17,1.72s-7.53,4.3-11.75,4.57c-3.68.24-7.67-1.13-10.89.67-2.39,1.34-3.65,4.1-5.86,5.73s-5,1.93-7.66,2.07-5.46.18-7.9,1.3-4.46,3.69-3.95,6.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,91.44c.75-5.43-6.91-9.9-12.67-10.37-2.75-.22-5.61.2-8.21-.7-5.64-2-7.89-9.25-13.39-11.57-4.11-1.74-8.85-.19-12.83,1.81s-7.93,4.53-12.39,4.82c-3.87.25-8.08-1.19-11.47.7-2.53,1.41-3.85,4.33-6.18,6s-5.25,2-8.07,2.19-5.76.18-8.33,1.36-4.7,3.9-4.17,6.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.46,298.2c1-7.32-9.32-13.34-17.08-14-3.71-.3-7.55.27-11.06-1-7.6-2.64-10.63-12.46-18.05-15.59-5.54-2.34-11.92-.26-17.3,2.45s-10.68,6.11-16.69,6.49c-5.22.34-10.89-1.6-15.46.95-3.4,1.9-5.19,5.83-8.33,8.14s-7.07,2.74-10.88,3-7.75.25-11.22,1.84-6.34,5.25-5.62,9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,246.18c.92-6.63-8.44-12.08-15.46-12.64-3.36-.27-6.84.24-10-.87-6.88-2.4-9.63-11.28-16.34-14.12-5-2.11-10.8-.23-15.66,2.22s-9.68,5.53-15.11,5.88c-4.73.3-9.86-1.45-14,.86-3.08,1.72-4.7,5.27-7.54,7.37s-6.4,2.48-9.85,2.67-7,.22-10.16,1.66-5.74,4.76-5.09,8.15Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473,427.27s-.5-.54-1.43-1.61c-.47-.53-1-1.22-1.79-1.94l-1.2-1.19a16.92,16.92,0,0,0-1.43-1.32l-1.65-1.42c-.57-.51-1.25-1-1.91-1.48-1.33-1.05-2.91-2-4.58-3.09a57.06,57.06,0,0,0-12.53-5.51,53.18,53.18,0,0,0-16.81-2.33l-2.35.07-2.39.24-1.21.12-1.21.21-2.45.44a54,54,0,0,0-9.88,3.24,55.9,55.9,0,0,0-9.62,5.52,59,59,0,0,0-8.78,7.84,53.83,53.83,0,0,0-12.1,22.09l-.06.23-.22-.08a37.13,37.13,0,0,0-18.72-1.1,56,56,0,0,0-18.57,7.22,66.13,66.13,0,0,0-16,13.48,51.36,51.36,0,0,0-10.57,18.9l-.05.17h-.18c-9.86.5-20,.39-30.43.19-5.19-.09-10.44-.18-15.74-.2l-16,0-67.77,0h-.15l-.07-.14a43.15,43.15,0,0,0-14.69-16,42.43,42.43,0,0,0-19.68-6.83,43.65,43.65,0,0,0-35.09,13.74l-.24.25-.12-.32A54.7,54.7,0,0,0,102,456.67a59.83,59.83,0,0,0-8.82-6.92A56.42,56.42,0,0,0,83.78,445a54.66,54.66,0,0,0-9.51-2.74l-2.35-.35-1.15-.16-1.16-.09-2.27-.18-2.24,0a53.65,53.65,0,0,0-16,2.32,57.51,57.51,0,0,0-12,5.09c-1.61,1-3.13,1.87-4.41,2.84a43,43,0,0,0-3.46,2.65c-1,.79-1.82,1.63-2.57,2.29A24.12,24.12,0,0,0,25,458.37c-.93,1-1.42,1.47-1.42,1.47s.46-.52,1.37-1.51a23.09,23.09,0,0,1,1.74-1.79c.74-.67,1.52-1.52,2.56-2.32a43.14,43.14,0,0,1,3.45-2.68c1.28-1,2.79-1.87,4.4-2.87a57.5,57.5,0,0,1,12-5.17,54,54,0,0,1,16-2.38l2.24,0,2.29.18,1.16.09,1.16.16,2.36.35a55,55,0,0,1,9.58,2.72,57.24,57.24,0,0,1,9.5,4.8,59.91,59.91,0,0,1,8.89,6.95,55.25,55.25,0,0,1,13.42,20.18l-.36-.07a44.17,44.17,0,0,1,35.45-13.92,42.88,42.88,0,0,1,19.91,6.89,43.68,43.68,0,0,1,14.87,16.18l-.23-.14,67.76,0,16,0c5.31,0,10.56.11,15.75.21,10.39.2,20.55.31,30.39-.19l-.23.19a51.83,51.83,0,0,1,10.69-19.08A66.47,66.47,0,0,1,341.86,453a56.2,56.2,0,0,1,18.73-7.26,37.43,37.43,0,0,1,18.94,1.14l-.28.15a54.25,54.25,0,0,1,12.23-22.25,59.71,59.71,0,0,1,8.85-7.87,56.08,56.08,0,0,1,9.7-5.55,55.46,55.46,0,0,1,10-3.24l2.47-.43,1.22-.21,1.22-.12,2.4-.23,2.36-.07a53.26,53.26,0,0,1,16.89,2.4,57.56,57.56,0,0,1,12.56,5.58c1.67,1.1,3.25,2.07,4.57,3.13.67.53,1.34,1,1.91,1.5l1.65,1.44a15.3,15.3,0,0,1,1.42,1.33l1.19,1.2a22.55,22.55,0,0,1,1.77,2C472.53,426.7,473,427.27,473,427.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248,50.83l5.22,10.6a2.58,2.58,0,0,0,1.93,1.39l11.69,1.7a2.56,2.56,0,0,1,1.41,4.36l-8.45,8.25a2.53,2.53,0,0,0-.74,2.26L261,91a2.56,2.56,0,0,1-3.71,2.7l-10.46-5.5a2.57,2.57,0,0,0-2.38,0L234,93.73a2.56,2.56,0,0,1-3.71-2.7l2-11.64a2.56,2.56,0,0,0-.74-2.26l-8.46-8.25a2.56,2.56,0,0,1,1.42-4.36l11.69-1.7a2.55,2.55,0,0,0,1.92-1.39l5.23-10.6A2.56,2.56,0,0,1,248,50.83Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,57.83c-.09.1-6.73-6.06-14.81-13.76s-14.56-14-14.46-14.13S205.5,36,213.59,43.7,228.14,57.73,228,57.83Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.18,64.35c0,.14-5.71-.09-12.72-.51s-12.7-.89-12.7-1,5.71.08,12.73.51S214.18,64.21,214.18,64.35Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.8,45.37a69.59,69.59,0,0,1-3.67-7.62,70.42,70.42,0,0,1-3.21-7.83,66.45,66.45,0,0,1,3.68,7.62A68.25,68.25,0,0,1,235.8,45.37Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.65,11.4c.14,0,.26,7,.26,15.56s-.12,15.57-.26,15.57-.26-7-.26-15.57S244.51,11.4,244.65,11.4Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.33,30.21a66.16,66.16,0,0,1-3.3,7.55,66.45,66.45,0,0,1-3.78,7.32,65.27,65.27,0,0,1,3.31-7.55A65.46,65.46,0,0,1,262.33,30.21Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.9,35.3c.08.12-7.55,5.58-17,12.2s-17.25,11.9-17.33,11.78,7.54-5.58,17-12.21S290.81,35.18,290.9,35.3Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.65,57.42A82.44,82.44,0,0,1,283.22,61,77.73,77.73,0,0,1,274.6,64,82.44,82.44,0,0,1,283,60.48,77.73,77.73,0,0,1,291.65,57.42Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,78.73c0,.13-9.87,3.67-22.15,7.89S180.72,94.16,180.68,94s9.87-3.67,22.15-7.9S225.11,78.59,225.15,78.73Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.32,89.63c0,.14-8.76-2.19-19.49-5.2s-19.4-5.56-19.36-5.7,8.77,2.19,19.5,5.2S303.36,89.49,303.32,89.63Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,107.7a64.65,64.65,0,0,1,5.91-5.48,60.61,60.61,0,0,1,6.26-5.1,63.23,63.23,0,0,1-5.92,5.49A63.15,63.15,0,0,1,217,107.7Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.48,132.19c-.14,0-.21-8.55-.16-19.08s.22-19.09.36-19.08.22,8.54.16,19.08S245.62,132.19,245.48,132.19Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,109.84a64.87,64.87,0,0,1-6.14-5.44A63.32,63.32,0,0,1,263,98.58a64.87,64.87,0,0,1,6.14,5.44A63.32,63.32,0,0,1,275,109.84Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,73.8l.09,1.72a.37.37,0,0,0,.18.3l1.46.9a.37.37,0,0,1-.06.67l-1.61.61a.36.36,0,0,0-.22.26l-.41,1.68a.37.37,0,0,1-.65.14l-1.08-1.33a.37.37,0,0,0-.32-.14l-1.72.13a.37.37,0,0,1-.34-.57l.94-1.45a.35.35,0,0,0,0-.34l-.66-1.6a.38.38,0,0,1,.44-.5l1.67.45a.39.39,0,0,0,.34-.08l1.31-1.11A.37.37,0,0,1,296.39,73.8Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,55.67l.79.82a.23.23,0,0,0,.21.07l1.12-.18a.25.25,0,0,1,.26.36l-.54,1a.24.24,0,0,0,0,.23l.52,1a.25.25,0,0,1-.27.35l-1.11-.2a.25.25,0,0,0-.22.06l-.8.81a.25.25,0,0,1-.42-.14l-.15-1.13a.23.23,0,0,0-.13-.18l-1-.52a.24.24,0,0,1,0-.44l1-.49a.22.22,0,0,0,.14-.18L307,55.8A.25.25,0,0,1,307.43,55.67Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,42.06l.78.82a.21.21,0,0,0,.21.07l1.12-.18a.25.25,0,0,1,.26.36l-.54,1a.24.24,0,0,0,0,.23l.52,1a.25.25,0,0,1-.27.35l-1.11-.2a.26.26,0,0,0-.22.07l-.8.8a.25.25,0,0,1-.42-.14L180,45.13a.26.26,0,0,0-.13-.19l-1-.51a.25.25,0,0,1,0-.44l1-.49a.25.25,0,0,0,.14-.19l.17-1.12A.25.25,0,0,1,180.61,42.06Z",
    style: {
      fill: "#AE460C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.11,283.83s-.42-.11-1.18-.26a9.33,9.33,0,0,0-3.22-.09,8.71,8.71,0,0,0-4.32,1.89,9.07,9.07,0,0,0-3,4.84v.06l-.19.71-.27-.68a9.67,9.67,0,0,0-3.65-4.41,9.5,9.5,0,0,0-4.46-1.52,12.44,12.44,0,0,0-4.37.56,3.94,3.94,0,0,1,1.11-.48,9.44,9.44,0,0,1,3.28-.42,9.65,9.65,0,0,1,4.68,1.48,10,10,0,0,1,3.86,4.61l-.46,0v-.06A9.3,9.3,0,0,1,72.11,285,9,9,0,0,1,80,283.38,3.66,3.66,0,0,1,81.11,283.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.51,280a18.76,18.76,0,0,1-1.51,1.75,38.11,38.11,0,0,0-3.72,5.05,36.73,36.73,0,0,0-5.52,19.59v.25l-.69.06a32.9,32.9,0,0,0-9-18,45.21,45.21,0,0,0-6.59-5.34,1.75,1.75,0,0,1,.54.25,14.6,14.6,0,0,1,1.48.85,28.79,28.79,0,0,1,4.91,3.9,32.3,32.3,0,0,1,9.36,18.23l-.68.05v-.25a36,36,0,0,1,5.8-19.86,32.17,32.17,0,0,1,3.93-5c.51-.55,1-.92,1.24-1.19S129.5,280,129.51,280Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.88,220.56c0,.05-.84-.29-2.39-.63a19,19,0,0,0-6.65-.26,18,18,0,0,0-9,3.87,18.6,18.6,0,0,0-6.32,10.05l0,.11-.19.72-.27-.68a19.94,19.94,0,0,0-7.58-9.15,19.29,19.29,0,0,0-9.25-3.09,20.54,20.54,0,0,0-6.61.61c-1.53.4-2.33.75-2.35.71a2.74,2.74,0,0,1,.57-.28,14.47,14.47,0,0,1,1.73-.61,19.72,19.72,0,0,1,16.15,2.28,20.31,20.31,0,0,1,7.79,9.34l-.46,0,0-.11a18.89,18.89,0,0,1,6.51-10.29,18.41,18.41,0,0,1,16-3.44,12.86,12.86,0,0,1,1.75.55A5.3,5.3,0,0,1,376.88,220.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.39,184.06s-.47-.13-1.32-.3a10.39,10.39,0,0,0-3.64-.11,9.73,9.73,0,0,0-4.87,2.13,10.07,10.07,0,0,0-3.44,5.47l0,.06-.18.72-.28-.68a10.86,10.86,0,0,0-4.12-5,10.54,10.54,0,0,0-5-1.7,11.6,11.6,0,0,0-3.62.29c-.84.21-1.29.39-1.3.35a1.17,1.17,0,0,1,.31-.17,7,7,0,0,1,.94-.36,10.86,10.86,0,0,1,8.95,1.22,11.12,11.12,0,0,1,4.33,5.18l-.46,0,0-.06a10.43,10.43,0,0,1,3.62-5.71,10.14,10.14,0,0,1,8.85-1.86,6.81,6.81,0,0,1,1,.33A1,1,0,0,1,443.39,184.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9,169.12s-.45.52-1.28,1.45a32.75,32.75,0,0,0-3.12,4.22,30.72,30.72,0,0,0-4.63,16.4v.21l-.49,0a26.88,26.88,0,0,0-3-8.89,27.6,27.6,0,0,0-4.56-6.16,26.92,26.92,0,0,0-4-3.36,18.34,18.34,0,0,1-1.57-1.09,2.52,2.52,0,0,1,.44.21c.28.17.72.38,1.23.72a24.16,24.16,0,0,1,4.1,3.27,27.2,27.2,0,0,1,7.8,15.23l-.48,0v-.21a30.33,30.33,0,0,1,4.83-16.6,27.52,27.52,0,0,1,3.28-4.15c.42-.47.79-.78,1-1A2.26,2.26,0,0,1,399.9,169.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.31,197.33H288c3.22,0,3.22-5,0-5H204.31c-3.22,0-3.23,5,0,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.2,
    y: 101.75,
    width: 6,
    height: 383.98,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,485.73c-.14,0-.26-85.91-.26-191.86s.12-191.87.26-191.87.26,85.89.26,191.87S207,485.73,206.89,485.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.31,158.48H288c3.22,0,3.22-5,0-5H204.31c-3.22,0-3.23,5,0,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.94,
    y: 102.53,
    width: 6,
    height: 383.19,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09,437.45c-.15,0-.26-74.83-.26-167.12s.11-167.14.26-167.14.26,74.82.26,167.14S285.23,437.45,285.09,437.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,453.26h83.74c3.21,0,3.22-5,0-5H204.2c-3.21,0-3.22,5,0,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,375.75h78.67c3.22,0,3.22-5,0-5H206c-3.22,0-3.23,5,0,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,321.58h83.74c3.21,0,3.22-5,0-5H204.2c-3.21,0-3.22,5,0,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,278.85h83.74c3.21,0,3.22-5,0-5H204.2c-3.21,0-3.22,5,0,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,237.13h83.74c3.21,0,3.22-5,0-5H204.2c-3.21,0-3.22,5,0,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,415.69h79.59c3.22,0,3.22-5,0-5H205c-3.22,0-3.22,5,0,5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.13,163.7l-5.08-11.31s.27-6-.59-6.56c-1.18-.7-1.47-.12-1.8,1.9l-.47,3s-1.94-4.23-3.75-4.4c-1.23-.12-1.58,2-1.58,2s-2.05-1.91-3.5-1.45-1,2.44-1,2.44a1.64,1.64,0,0,0-2.46.79c-.85,2.07,2.88,5.21,3.45,6.6,1.19,2.9-1.34,3-1.34,3s-6.49-.83-6.16.84,2.5,1.66,4.17,1.83c1.38.14,6.6,1.44,8.29,1.86a3.43,3.43,0,0,1,1,.44l3.88,4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.5 423.46 270.28 452.5 254.61 452.69 254.77 423.6 270.5 423.46",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.55,451.5c-.14,0-.11-6.36,0-14.2s.4-14.19.53-14.19.11,6.36-.05,14.2S262.68,451.5,262.55,451.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,443.4a2.05,2.05,0,0,1,.41-.63,10,10,0,0,1,1.41-1.48,10.52,10.52,0,0,1,2.55-1.67,8.36,8.36,0,0,1,9.74,1.92,7.07,7.07,0,0,1,1.13,1.72,2.06,2.06,0,0,1,.24.71,16.92,16.92,0,0,0-1.62-2.2,8.35,8.35,0,0,0-5.84-2.48,9.59,9.59,0,0,0-6,2.26C255.37,442.6,254.73,443.45,254.66,443.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.62 434.11 254.6 437.31 270.5 437.31 270.5 434.11 254.62 434.11",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.61 452.69 254.63 449.66 270.3 449.67 270.28 452.5 254.61 452.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.63 348.11 237.42 375.97 222.39 376.16 222.54 348.24 237.63 348.11",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,375c-.12,0-.1-6.1.05-13.62s.38-13.62.5-13.62.11,6.1-.05,13.63S230.13,375,230,375Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,367.23s.11-.23.39-.6a9.87,9.87,0,0,1,1.36-1.42,10.11,10.11,0,0,1,2.44-1.6,8,8,0,0,1,9.35,1.85,6.84,6.84,0,0,1,1.08,1.64,1.81,1.81,0,0,1,.23.69,14.25,14.25,0,0,0-1.55-2.11,8,8,0,0,0-5.61-2.38,9.15,9.15,0,0,0-5.74,2.16C223.12,366.47,222.5,367.29,222.44,367.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.39 358.32 222.38 361.39 237.63 361.39 237.63 358.32 222.39 358.32",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.39 376.16 222.4 373.25 237.44 373.25 237.42 375.97 222.39 376.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5,161.32l.4-.1a7.48,7.48,0,0,1,6.11-3.65,9.71,9.71,0,0,1,6.79,2.53c1.29,1.15,2.31,2.57,3.6,3.7a5.69,5.69,0,0,0,4.71,1.64c.2.63-1,1-.9,1.65a.79.79,0,0,0,.67.59,9.09,9.09,0,0,0,1.38,0,1.1,1.1,0,0,1,1.1.67,1.28,1.28,0,0,1-.06.67,11.91,11.91,0,0,1-2.73,5.36,6.27,6.27,0,0,1-5.48,2,10,10,0,0,1-4.18-2.36l-7.2-5.77a16.34,16.34,0,0,1-3.06-2.93A5.47,5.47,0,0,1,240.5,161.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,161.72a7.89,7.89,0,0,0-3.35-1.66,4.7,4.7,0,0,0-3.6.69,10.6,10.6,0,0,0-2.2,2.72,4.38,4.38,0,0,1-2.72,2.07,1,1,0,0,0-.57.18c-.27.25-.08.74.25.89a1.7,1.7,0,0,0,1.07,0,3.77,3.77,0,0,1-2.25,1.27,1.65,1.65,0,0,0,2,1.17,17.19,17.19,0,0,0-.66,4.14,5.76,5.76,0,0,0,1.35,3.88c1,1.13,2.75,1.76,3.21,3.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.09,211.14l-18.72-.24,2.09-16s-1.28-.28-1.36-7.22-.41-18.75-.41-18.75h0A24.1,24.1,0,0,1,257.91,172l1,.79Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.77,181.36c.12-.06,4.76-1.42,4.61,3.33s-4.88,3.62-4.88,3.48S256.77,181.36,256.77,181.36Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,180.36c-.12-.05-4.35-1.19-4.19,3.56s4.88,3.62,4.88,3.48S234.5,180.36,234.5,180.36Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,180.83c-.7,4-.56,6.06-1.22,8.72-1,4.21-3.12,7.43-6.91,9.53s-8.9,2.06-12.14-.8a11.06,11.06,0,0,1-4.19-7.21c-.34-3-1.22-8.6-1.24-11.6,0-5.42.15-10.28.15-10.28l15.46-2.81,8.8,5.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,201.48a6.87,6.87,0,0,0,5.3-.59c0-.12-1.18.24-2.64.4S242.37,201.35,242.35,201.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.56,187.59c.45-4.08.74-8.74,1.38-13a27.69,27.69,0,0,0,.67-5.56c-.14-1.63-.59-1.13-1.31-2.61-.9-1.84-4.33-3.07-6.34-3.47s-2.26-2.15-3.8-.8a5,5,0,0,0-9.16,2.12,3.49,3.49,0,0,0-5.75,3.5A3.42,3.42,0,0,0,231,173c.72,1.1,2,1.71,2.8,2.76A4,4,0,0,1,234,180",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.63,186.74a7.5,7.5,0,0,0,.54,4.17,7.57,7.57,0,0,0,2.35,3.49,27.23,27.23,0,0,1-2-3.64A26.86,26.86,0,0,1,237.63,186.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.55,183.28a6.16,6.16,0,0,0-.3,3.76,6.09,6.09,0,0,0,1.61,3.41,20.44,20.44,0,0,1-1.18-3.49A22.28,22.28,0,0,1,235.55,183.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,166.86a10.66,10.66,0,0,0-4.82-4.32,6.22,6.22,0,0,0-6.22.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.64,177.37c-.08,0,0-.55.15-1.4a17.53,17.53,0,0,0,.36-3.29,7.26,7.26,0,0,0-.71-3.15c-.37-.74-.74-1.13-.68-1.19s.53.24,1,1a6.34,6.34,0,0,1,.92,3.34,11.79,11.79,0,0,1-.53,3.38C254.92,176.9,254.71,177.39,254.64,177.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.44,178.94a8.19,8.19,0,0,1,.62-2.19,8,8,0,0,1,.76-2.15,3.69,3.69,0,0,1-.24,2.32C252.19,178.15,251.57,179,251.44,178.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.59,177.72a3.87,3.87,0,0,1-1.06-1.69,8.41,8.41,0,0,1-.47-4.82,8.52,8.52,0,0,1,2.28-4.27,4,4,0,0,1,1.64-1.16c.05.08-.58.51-1.35,1.42a8.9,8.9,0,0,0-1.74,8.69C236.26,177,236.67,177.68,236.59,177.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,160.06a6.88,6.88,0,0,1-1.53-.64,8.88,8.88,0,0,0-3.73-.92,4.49,4.49,0,0,0-3.38,1.43,10.27,10.27,0,0,0-.87,1.35,2.18,2.18,0,0,1,.57-1.6,4.21,4.21,0,0,1,1.44-1.21,5.05,5.05,0,0,1,2.23-.52,7.89,7.89,0,0,1,3.92,1.12A4.33,4.33,0,0,1,253.5,160.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,164.46c-.06,0,.05-.55.55-1.26a5.11,5.11,0,0,1,6-1.75c.79.33,1.17.72,1.13.77a10.2,10.2,0,0,1-1.26-.4,5.43,5.43,0,0,0-5.6,1.63C232.66,164,232.43,164.5,232.35,164.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.45,181.91c0-.07.76-.27,2-.83A16.17,16.17,0,0,0,244,178l.89-.87-.49,1.15a11,11,0,0,0-.67,2.26c-.07.39-.13.88,0,.95s.53-.1.89-.35a14.07,14.07,0,0,0,3.18-2.81l.82-1-.37,1.22-1.05,3.4-.36-.21a20.61,20.61,0,0,0,3-3.82,4,4,0,0,1-.53,1.23,13,13,0,0,1-2.2,2.9l-.58.58.23-.8c.29-1,.61-2.19,1-3.42l.45.24a14.3,14.3,0,0,1-3.29,3,6.62,6.62,0,0,1-.61.35.89.89,0,0,1-.9,0,.93.93,0,0,1-.3-.82c0-.25.06-.44.09-.66a10.67,10.67,0,0,1,.74-2.36l.41.28a14.63,14.63,0,0,1-4.81,3A6.37,6.37,0,0,1,237.45,181.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.5,163.6a2.46,2.46,0,0,0-1.5-1.15,4.29,4.29,0,0,0-1.92,0,6.91,6.91,0,0,0-4,2.34c-.23.27-.44.7-.19,1a.81.81,0,0,0,.53.18,29.73,29.73,0,0,0,7-.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.93,303.05c.31.56,4.1,13.24,12.46,15.39s34.41.72,35.12,0,8.37-4.94,12.07-13.7-22.87-24.05-22.87-24.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,306.48l.23,7.07c0,1.09-.13,6.57-.25,7.65l-3.25,43.91c-.32-.13-2.21,27-2.37,36.52-.16,9.16-.93,34.08-.93,34.08H252.05l-1.44-41.26-.9-44.66-1.32-31.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.93,296.06s.47.7.36,10.42c-.08,7.43,4.43,53.23,4.43,53.23l18.25-.55,3.65-45.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07,319.09a9.14,9.14,0,0,1-1.53.21c-1,.11-2.42.24-4.2.35a50.46,50.46,0,0,1-13.89-.81,19.94,19.94,0,0,1-11.79-7.12,13.58,13.58,0,0,1-2-3.73,9.24,9.24,0,0,1-.31-1.11c-.06-.26-.08-.4-.06-.4a17.49,17.49,0,0,0,2.66,5,20.2,20.2,0,0,0,11.61,6.84,56,56,0,0,0,13.76,1l4.21-.19A8.27,8.27,0,0,1,250.07,319.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,318.21a10.27,10.27,0,0,1-2.34.62,56.57,56.57,0,0,1-11.62,1,10.68,10.68,0,0,1-2.41-.2,12.31,12.31,0,0,1,2.41-.17c1.48-.06,3.53-.16,5.79-.36s4.3-.45,5.77-.66A12.11,12.11,0,0,1,271.71,318.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.09,326.25a15.88,15.88,0,0,1-3.09-.31c-1.89-.28-4.49-.77-7.33-1.47s-5.37-1.48-7.18-2.11a16.36,16.36,0,0,1-2.88-1.16,21.4,21.4,0,0,1,3,.81c1.83.54,4.37,1.26,7.19,2s5.41,1.23,7.28,1.61A20.3,20.3,0,0,1,271.09,326.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,172.42a44.39,44.39,0,0,0-2.64-4.67s5.9-6.25,9.45-6.06l3.37,4.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94,192.07c-1.29-4-17.46-27.35-17.46-27.35-6,0-11.78,7.23-11.78,7.23l11.49,24.2-12.08,11.12,13.64,16.11s8.61-10.77,11.19-14.67C294.69,200,295.22,196.09,293.94,192.07Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.41,301.76s1.35,9,8.87,11.65,24.89,0,24.89,0l2-6.55,2.16,7.73,26.87-3.44-.38-6.14-28.48-11.83Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,271.81c-.57-3.18-1.3-4.79-1.44-6.71-.43-5.73-.4-19.47,0-21.23.51-2.31,5.18-20.49,5.18-20.49l-1.59-14.08L256.31,206l-1.39-3.2s-13.24-3.43-21.61,1.07h0l-1.45,3.42-5.17,1.3c-.78.31-4.83,1.44-7.9,2.27a12,12,0,0,0-7.78,6.5,34.32,34.32,0,0,0-1.39,3.53c-1.37,4.06-9.25,26.5-9.6,33.34-.41,8,6.67,8.27,11,7.25s9.07-10.7,9.07-10.7l2.72,18.94a43.09,43.09,0,0,1-1.89,7.6c-2.64,7.2-6.44,21.13-6.44,21.13,1.48,4.64,6.86,12,9.68,13s21.67.19,21.67.19l5.56-14.75,5.13,15.51,26.75-4.17Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.36,266.35c.07.12-3.78,2.67-8.6,5.68a103.06,103.06,0,0,1-8.88,5.25,102.19,102.19,0,0,1,8.6-5.69A101.26,101.26,0,0,1,251.36,266.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.32,274.13c.07.12-4,2.84-9.15,6.08s-9.34,5.76-9.42,5.64,4-2.84,9.15-6.08S244.24,274,244.32,274.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.47,252.93a15.54,15.54,0,0,1-3.21,5,15.27,15.27,0,0,1-4.54,3.8c-.1-.12,2-1.71,4.15-4.14S265.33,252.85,265.47,252.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,255.46a8,8,0,0,1-.9,2,39,39,0,0,1-2.84,4.47,37.63,37.63,0,0,1-3.44,4,7.41,7.41,0,0,1-1.65,1.45c-.11-.11,2.24-2.49,4.67-5.8S265.87,255.38,266,255.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.63,280a16.39,16.39,0,0,1,.69-2.67c.47-1.63,1.09-3.89,1.68-6.42s1-4.82,1.32-6.5a18.16,18.16,0,0,1,.55-2.7,12.32,12.32,0,0,1-.19,2.76A62.84,62.84,0,0,1,269.5,271a64.78,64.78,0,0,1-1.83,6.41A13.38,13.38,0,0,1,266.63,280Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,221.17c-.14.08-1.92-3-4.61-6.43s-5.23-5.92-5.12-6a8.55,8.55,0,0,1,1.78,1.51,41.2,41.2,0,0,1,3.75,4.2,42.49,42.49,0,0,1,3.16,4.66A8.75,8.75,0,0,1,276.48,221.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.77,214.05a23.3,23.3,0,0,0-4-4.36,23,23,0,0,0-5.2-2.78,4.33,4.33,0,0,1,1.75.34,12.75,12.75,0,0,1,6.66,5.2A4.49,4.49,0,0,1,280.77,214.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.78,269.68c-.14,0-1.75-10.33-3.58-23.11s-3.21-23.17-3.06-23.19,1.74,10.33,3.58,23.11S222.92,269.65,222.78,269.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59,206a35.55,35.55,0,0,1-3.65-.1c-2.26-.09-5.37-.13-8.81,0s-6.53.52-8.76.83a34.24,34.24,0,0,1-3.63.47,4.5,4.5,0,0,1,.95-.29c.61-.15,1.51-.34,2.62-.54a68.88,68.88,0,0,1,8.8-1,70.93,70.93,0,0,1,8.85.11c1.13.09,2,.19,2.67.28A3.88,3.88,0,0,1,256.59,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.16,251.46c-1.06-8-2.52-16-3.58-24C213.69,235.33,215.28,244.62,220.16,251.46Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276,195.84a12.22,12.22,0,0,1,6.84-3.26,4.4,4.4,0,0,1,3.5.72.85.85,0,0,1,.35.7.66.66,0,0,1-.56.51,2,2,0,0,1-.81,0c-3.07-.55-6.4.35-9.31,1.47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.87,207.37a20.85,20.85,0,0,0,7.88.4q7-.61,13.94-1.82a58.94,58.94,0,0,0-22.29,1.25"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232,282.28a57.45,57.45,0,0,0,27.38-17.18C251,270.39,240.15,276.46,232,282.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M282.48,194.65a14.83,14.83,0,0,0-3.56.28,14.48,14.48,0,0,0-3.19,1.62c-.05,0,.17-.41.69-.86a6.15,6.15,0,0,1,2.35-1.26,6.31,6.31,0,0,1,2.67-.16C282.12,194.39,282.5,194.59,282.48,194.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.49,183.08l-9.21.42A24.8,24.8,0,0,1,164,191.13a24.34,24.34,0,0,1-30.89-16.32A25.68,25.68,0,0,1,149.36,143a24.32,24.32,0,0,1,30.88,16.33,25.77,25.77,0,0,1-.43,16.35h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.49,183.08l-.33-.49-.92-1.43-3.52-5.46h.18a.11.11,0,0,1-.16,0,.12.12,0,0,1,0-.14A26.06,26.06,0,0,0,181,163.29a24.78,24.78,0,0,0-2.38-7.63,24.29,24.29,0,0,0-13.79-12.31,24,24,0,0,0-10.55-1.19A24.9,24.9,0,0,0,143.67,146a24.29,24.29,0,0,0-8,8.61,24.79,24.79,0,0,0-3.29,11.2,25.77,25.77,0,0,0,1.8,11,24.36,24.36,0,0,0,14.27,13.84,24,24,0,0,0,16.63-.12,24.83,24.83,0,0,0,10.13-7.16.15.15,0,0,1,.09,0l6.81-.23,1.78-.06h.62l-.57,0-1.74.11-6.89.39.08,0a24.86,24.86,0,0,1-10.19,7.32,24.21,24.21,0,0,1-16.9.21,24.75,24.75,0,0,1-14.58-14.06,26.17,26.17,0,0,1-1.86-11.24,27.61,27.61,0,0,1,1-5.86,27.19,27.19,0,0,1,6-10.5,26.26,26.26,0,0,1,4.6-3.85,25.27,25.27,0,0,1,10.79-3.94,24.49,24.49,0,0,1,19.34,6.46,25,25,0,0,1,5.41,7.36,25.33,25.33,0,0,1,2.36,7.76,26,26,0,0,1-1.38,12.45l-.2-.1h0a.11.11,0,0,1,.16,0l0,0c1.5,2.44,2.65,4.32,3.45,5.61l.86,1.42C184.41,182.93,184.49,183.08,184.49,183.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.88 163.02 156.22 153.71 163.56 162.9 148.88 163.02",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.84 180.04 153.15 180.09 152.94 161.51 159.62 161.46 159.84 180.04",
    style: {
      fill: "#AE460C"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card-2.9b7599e4aea8631cc84f66dcf00b7cf1.svg";
export { ForwardRef as ReactComponent };